import { Organizer } from "../../../../../../../shared/types/OrganizerTypes"
import { getOrderPerson } from "../../../../../../../shared/utils/getOrderPerson"

export interface ContactInfo {
    creator?: Organizer
    meetingHost?: Organizer
    showBoth: boolean
}

export const getContactInfo = (organizers?: Organizer[]): ContactInfo => {
    if (!organizers || organizers.length === 0) {
        return { showBoth: false }
    }
    const { creator, person: meetingHost } = getOrderPerson(organizers)

    // If creator and meeting host are the same person, show only meeting host
    if (creator && meetingHost && creator.name === meetingHost.name && creator.email === meetingHost.email) {
        return {
            meetingHost,
            showBoth: false,
        }
    }
    return {
        creator,
        meetingHost,
        showBoth: true,
    }
}
